<template>
  <div class="navbar">
    <!-- 
    <transition name="fade-transform" mode="out-in">
      <el-breadcrumb separator="/" class="route">
        <el-breadcrumb-item><span>首页</span></el-breadcrumb-item>
        <el-breadcrumb-item v-if="this.$route.meta.titleParent != 'wu'"
          ><span>{{ $route.meta.titleParent }}</span></el-breadcrumb-item
        >
        <el-breadcrumb-item v-if="this.$route.meta.titleParent != 'wu'"
          ><span>{{ $route.meta.title }}</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </transition> -->
    <div class="right-menu" style="display: flex">
      <!-- 11 -->
      <span class="days" :style="{color: list[state].color, background: list[state].bgColor,  borderColor:list[state].color}">客莱宝有效期剩余 {{days!=null || days != undefined ? days : 0}}天</span>
      <!-- <el-dropdown class="avatar-container right-menu-item" placement="bottom" trigger="click"> -->
      <el-dropdown
        class="avatar-container right-menu-item"
        placement="bottom"
        trigger="click"
      >
        <!-- <div class="avatar-wrapper">
          <img class="user-avatar" :src="user.avatar" />
        </div> -->
        <span class="avatar-name">{{ getAvatarName(user.name) }}</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div style="font-size:12px;padding:0 20px;" @click="exit()">
              退出
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <template>
        <!-- www -->
        <div class="right-txt">
          <span style="font-size: 14px">{{ user.name }}</span>
          <!-- <span style="font-size: 1px; color: #a09f9fc9"
            >--{{ user.qyName }}
          </span> -->
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import "../assets/icon/iconfont.css";
import {
  getLoginUserInfo,
  jwtTest,
} from "../api/loginuserinfo/loginuserinfo.js"
import {out, getDaysRemaining} from "../api/index.js"
export default {
  props: ["user"],
  name: "Navcon1",
  data() {
    return {
      list: [{
        bgColor: '#d7eaff',
        color: '#1a70c9'
      },{
        bgColor: '#f7eb8a',
        color: '#9b6550'
      },
      {
        bgColor: '#ffc9c9',
        color: '#bc2121'
      }],
      state: 0,
      days: 0
    };
  },
  created() {
    var getRoute = this.$route;
    // console.log('asdasdasd111111')
    this.getDaysRemaining()
  },
  methods: {
   
      // 医院租用客莱宝过期时间
    getDaysRemaining(){
      getDaysRemaining(localStorage.getItem("Authorization")).then(res=>{
        this.days = res.data
        if(res.data >90){
          this.state =0
        }else if(res.data >60 && res.data <=90){
          this.state =1
        }else {
          this.state = 2
        }
        // console.log('asdasdasd')
      })
    },
    getAvatarName(str) {
      let reg = /[\u4e00-\u9fa5]/g;
      if (str) {
        str = str.match(reg) == null ? "" : str.match(reg).join("");
        let avatorName = "";
        if (str.length > 2) {
          avatorName = str.substring(str.length - 2);
        } else if (str.length != 0) {
          avatorName = str;
        } else {
          avatorName = "默认";
        }
        return avatorName;
      }
    },
    exit() {
      this.$confirm("退出登录, 是否继续?", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true,
      })
        .then(() => {
          out(localStorage.getItem("Authorization"))
            .then((res) => {
              if (res.error.code == 200) {
                setTimeout(() => {
                  localStorage.removeItem("Authorization");
                  localStorage.removeItem("url");
                  localStorage.removeItem("routerList");
                  localStorage.removeItem("myDepartment");
                  localStorage.removeItem("userId");
                  this.$router.push({ path: "/login" });
                  this.$message({
                    type: "success",
                    message: "已退出登录!",
                  });
                }, 1000);
              }
            })
            .catch((err) => {
              that.$message.error("退出失败，请重试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
};
</script>
<style lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  padding-right: 41px;
  border-radius: 0px !important;
  .buttonimg {
    height: 50px;
    background-color: transparent;
    float: left;
    border: none;
    .showimg {
      width: 26px;
      height: 26px;
      position: absolute;
      top: 17px;
      //left: 17px;
    }
    .showimg:active {
      border: none;
    }
  }
  /* 消失时间持续0.5s */
  .fade-transform-enter-active {
    transition: all 0.5s;
  }
  /* 显示时间持续0.5s */
  .fade-leave-active {
    transition: all 0.5s;
  }
  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
  .route {
    margin-top: 18px;
    // color: #97a8be !important;
    float: left;
  }
  /deep/ .el-breadcrumb__inner {
    color: #97a8be;
    //margin-top: 10px;
  }
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    .days {
      border-radius: 10px; 
      padding: 4px; 
      border: 1px solid #238bfc;
      height: 20px; font-size: 10px; 
      line-height: 20px;
      margin-top: 10px;
    }
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
      height: 20px;
    }

    .right-menu-item {
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 100%;
      margin-right: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
      .avatar-name {
        cursor: pointer;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        line-height: 32px;
        text-align: center;
        background: rgba(72, 145, 255, 0.2);
        color: #4891ff;
        font-size: 12px;
      }
      .avatar-wrapper {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        overflow: hidden;
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  .right-txt {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    line-height: normal;
  }
}
.delete-messege {
  /deep/ .el-icon-warning {
    color: #1296db !important;
    font-size: 40px;
    transform: rotate(180deg);
  }
}
</style>
